// The public name is separate from the name supplied by a sign-in provider.
export function usernameForm({ getSession, getStanding, setHandle, onSaved }) {
	const el = (tag, cls, text) => { const node = document.createElement(tag); if (cls) node.className = cls; if (text != null) node.textContent = text; return node; };
	const form = el("form", "rv-account-public-name");
	const label = el("label", "rv-account-note", "Public username");
	const input = el("input", "rv-input");
	input.type = "text"; input.minLength = 2; input.maxLength = 24; input.required = true; input.autocomplete = "off"; input.spellcheck = false;
	label.append(input);
	const note = el("p", "rv-account-note", "Used in Study Hall, community posts and the leaderboard. Choose a nickname, not your real full name. Your sign-in details stay the same. Names can usually change once every 7 days.");
	const save = el("button", "rv-btn", "Save username"); save.type = "submit";
	const status = el("p", "rv-account-note", "Loading your username..."); status.setAttribute("role", "status");
	form.append(label, note, save, status);
	const sub = getSession()?.profile?.sub;
	const sameAccount = () => !!sub && getSession()?.profile?.sub === sub;
	input.disabled = save.disabled = true;
	Promise.resolve().then(() => {
		if (!sameAccount()) throw new Error("Sign in to change your public username.");
		return getStanding();
	}).then(standing => {
		if (!sameAccount()) return;
		input.value = standing.handle || "";
		input.disabled = save.disabled = false;
		status.textContent = input.value ? "Your current public username is " + input.value + "." : "You haven't chosen a public username yet.";
	}).catch(error => { status.textContent = error.message || "Couldn't load your username. Reopen Account settings to try again."; });
	form.addEventListener("submit", async event => {
		event.preventDefault();
		if (save.disabled) return;
		if (!sameAccount()) { input.disabled = save.disabled = true; status.textContent = "Your account changed. Reopen Account settings before saving."; return; }
		const name = input.value.trim();
		if (name.length < 2 || name.length > 24) { status.textContent = "Choose a username with 2 to 24 characters."; return; }
		input.disabled = save.disabled = true;
		status.textContent = "Saving username...";
		try {
			const result = await setHandle(name);
			if (!sameAccount()) return;
			input.value = result.handle;
			status.textContent = "Your public username is now " + result.handle + ".";
			if (onSaved) onSaved(result.handle);
		} catch (error) { if (sameAccount()) status.textContent = error.message || "Couldn't save your username. Try again."; }
		finally { if (sameAccount()) input.disabled = save.disabled = false; }
	});
	return form;
}
